var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar_box"},[(_vm.nav_name == 'headerNavPc')?_c('headerNavPc',{staticClass:"headerNavPc"}):_c('headerNavMove',{staticClass:"headerNavMove"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }